module.exports = __webpack_public_path__ + "static/media/playstation.71240f44.svg";